const list = {
    or: 'o',
    and: 'y',
    separator: ',',
};
export default Object.freeze(list);
